<template>
  <div class="case-family-pedigree-page">
    <familyPedigree
      :pedigreeDatas="pedigreeDatas"
    ></familyPedigree>
  </div>
</template>

<script>
import { familyRelationOptions } from '../../constants/global/data'
import { fixNumber, groupBy } from '../../constants/global/util'

export default {
  props: {
    caseData: {
      type: Object,
      required: true
    },
    variant: {
      type: Object,
      required: true
    },
    sampleAllelegts: {
      type: Object,
      required: true
    }
  },
  computed: {
    pedigreeDatas () {
      let familyInfos = this.variant.fam_info || []
      let sampleAllelegt = this.sampleAllelegts[[this.variant.CHROM, this.variant.POS, this.variant.REF, this.variant.ALT].join(':')] || []
      sampleAllelegt = sampleAllelegt.reduce((result, data) => (data.sample ? { ...result, [data.sample]: { 'GT': data.gt, 'RefAlt': data.refalt } } : result), {})
      const familyRelationMap = familyRelationOptions.reduce((map, option) => ({ ...map, [option.value]: option }), {})
      const familyGroupKeys = Object.keys(groupBy(familyRelationOptions, option => option.group, true))
      let familyDataLayout = familyGroupKeys.reduce((layout, key) => ({ ...layout, [key]: { main: null, subs: [] } }), {})
      familyInfos.forEach(info => {
        let relationOption = info.relation !== 'Proband' ? familyRelationMap[info.relation] : { sex: this.caseData.sex }
        let refalt = (sampleAllelegt[info.sample_id || info.sample_number] || {}).RefAlt || info.RefAlt
        let gt = (sampleAllelegt[info.sample_id || info.sample_number] || {}).GT || info.GT
        let data = {
          title: info.case_id || '- -',
          RefAlt: refalt ? refalt.replace(/\//, ' > ') : '　',
          GT: gt || '　',
          QC: [
            ['DP', info.DP],
            ['AF', fixNumber(info.GT_AF, 0.01)],
            ['GQ', info.GQ, (info.GQ || 0) < 20]
          ].filter(data => data[1] || (data[1] === 0)).map((data, index) => '<span ' + (data[2] ? 'class=alert' : '') + '>' + data[0] + ':' + data[1] + '</span>' + (index < 2 ? ';' : '')),
          sex: relationOption.sex,
          affected: info.phenotype === 2,
          relation: info.relation
        }
        if (familyDataLayout[info.relation]) {
          familyDataLayout[info.relation].main = data
        } else {
          familyDataLayout[relationOption.group].subs.push(data)
        }
      })
      let familyGroupDatas = familyGroupKeys.reduce((data, key) => {
        let datas = [familyDataLayout[key].main || (familyDataLayout[key].subs.length ? {} : null), ...familyDataLayout[key].subs].filter(x => x)
        return { ...data, [key]: datas.length ? datas : null }
      }, {})
      const grandLength = [
        'Paternal Grandfather',
        'Paternal Grandmother',
        'Maternal Grandfather',
        'Maternal Grandmother'
      ].reduce((length, key) => length + (familyGroupDatas[key] || []).length, 0)
      let pedigreeDatas = {
        nodes: familyGroupDatas['Proband'] || [{ sex: this.caseData.sex }],
        hasParent: this.variant.type !== 'single',
        hiddenParent: false,
        fathers: {
          nodes: [...(familyGroupDatas['Father'] || [{ sex: familyRelationMap['Father'].sex }])].reverse(),
          hasParent: grandLength > 0,
          hiddenParent: grandLength && (!familyGroupDatas['Paternal Grandfather'] && !familyGroupDatas['Paternal Grandmother']),
          fathers: {
            nodes: familyGroupDatas['Paternal Grandfather'] || [{ sex: familyRelationMap['Paternal Grandfather'].sex }]
          },
          mothers: {
            nodes: familyGroupDatas['Paternal Grandmother'] || [{ sex: familyRelationMap['Paternal Grandmother'].sex }]
          }
        },
        mothers: {
          nodes: familyGroupDatas['Mother'] || [{ sex: familyRelationMap['Mother'].sex }],
          hasParent: grandLength > 0,
          hiddenParent: grandLength && (!familyGroupDatas['Maternal Grandfather'] && !familyGroupDatas['Maternal Grandmother']),
          fathers: {
            nodes: familyGroupDatas['Maternal Grandfather'] || [{ sex: familyRelationMap['Maternal Grandfather'].sex }]
          },
          mothers: {
            nodes: familyGroupDatas['Maternal Grandmother'] || [{ sex: familyRelationMap['Maternal Grandmother'].sex }]
          }
        }
      }
      const setPedigreeLength = pedigreeData => {
        let fatherLegnth = pedigreeData.fathers ? setPedigreeLength(pedigreeData.fathers) : 0
        let motherLegnth = pedigreeData.mothers ? setPedigreeLength(pedigreeData.mothers) : 0
        let childLength = Math.max(fatherLegnth, motherLegnth)
        pedigreeData.fathers && (pedigreeData.fathers.nodeLength = childLength)
        pedigreeData.mothers && (pedigreeData.mothers.nodeLength = childLength)
        let nodeLength = (pedigreeData.nodes || []).length || 0
        return Math.max(childLength * 2, nodeLength)
      }
      setPedigreeLength(pedigreeDatas)
      return pedigreeDatas
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/case/familyPedigree.vue